import { ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FakeLink from "../FakeLink/FakeLink";
import Skeleton from "../Skeleton/Skeleton";
import styles from "./PageHeader.module.scss";

export function PageHeader({
  title,
  description,
  loading,
  right,
}: {
  title?: string;
  description?: React.ReactNode;
  loading?: boolean;
  right?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (title) {
      window.document.title = title + " · Root Sustainability";
    }
  }, [title]);

  return (
    <div className={styles.PageHeader}>
      <div className={styles.container}>
        <div className={styles.title}>
          {location.key !== "default" && (
            <FakeLink
              onClick={() => {
                navigate(-1);
              }}
              className={styles.arrow}
            >
              <ArrowLeftOutlined />
            </FakeLink>
          )}
          <h1>{loading ? <Skeleton style={{ width: "200px", height: "36px" }} /> : title}</h1>
        </div>
        {right && <div className={styles.right}>{right}</div>}
      </div>
      {description && <p>{description}</p>}
    </div>
  );
}
